// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  loanId: __t.u64().primaryKey().name("loan_id"),
  bankId: __t.u64().name("bank_id"),
  borrower: __t.identity(),
  principal: __t.i64(),
  fee: __t.i64(),
  rateBps: __t.u32().name("rate_bps"),
  termDays: __t.u32().name("term_days"),
  installment: __t.i64(),
  balance: __t.f64(),
  accruedAt: __t.timestamp().name("accrued_at"),
  due: __t.f64(),
  dueSince: __t.timestamp().name("due_since"),
  dueLate: __t.bool().name("due_late"),
  nextDueAt: __t.timestamp().name("next_due_at"),
  finalDueAt: __t.timestamp().name("final_due_at"),
  missed: __t.u32(),
  lateCount: __t.u32().name("late_count"),
  paidTotal: __t.i64().name("paid_total"),
  secured: __t.bool(),
  autopay: __t.bool(),
  state: __t.string(),
  createdAt: __t.timestamp().name("created_at"),
  closedAt: __t.timestamp().name("closed_at"),
});
